"use client";
import React, {useEffect, useState} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import SDialogHeader from "@/app/_components/SDialogHeader/SDialogHeader";
import ComBG from "@/app/_components/ComBG/ComBG";
import RedeemCashOutUI from "@/app/(redeem)/redeemCashOut/RedeemCashOutUI";
import ScrollableContainer from "@/app/_components/ScrollableContainer/ScrollableContainer";
import TrackRedeem from "@/Core/Track/TrackRedeem";
import FontIcon from "@/app/_components/FontIcon/fontIcon";

interface RedeemCashOutProps extends SDialogProps {
    channelData: ResponseRedeemConfigData,
    channelCheckData: ResponseRedeemChannelCheckData
}

export const RedeemCashOutDialogFC: React.FC<RedeemCashOutProps> = (props) => {
    const {fcKey, onClose, channelData, channelCheckData} = props;
    const {closeDialog} = useDialogMethods(fcKey);
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        TrackRedeem.redeem_amount_show();
        return () => {
        };
    }, [props]);

    // ========== 按钮点击逻辑 ==========
    const onClickBack = () => {
        closeDialog();
        onClose?.();
    };

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            onClose={onClose}
        >
            <ComBG>
                <SDialogHeader
                    title="Cash Redemption"
                    icon={<FontIcon
                        icon={'s-safety'}
                        style={{
                            color: '#ffffff',
                            marginRight: '0.2rem',
                        }}
                    />}
                    onClickBack={onClickBack}
                />
                <ScrollableContainer>
                    {/*<div className={"header_panel"}></div>*/}
                    <RedeemCashOutUI channelData={channelData} channelCheckData={channelCheckData}/>
                </ScrollableContainer>
            </ComBG>
        </SDialogFC>
    );
};
